export default __webpack_public_path__ + "static/feedPlaceholder-3a41beaff973aaba60950fa36f2c0cc8.png";